<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#ff4081" type="timer" [fullScreen]="true">
    <p style="color: white;">Loading...</p>
</ngx-spinner>

<div class="container">
    <!-- Header Section -->
    <div class="header-card">
        <div class="header-content">
            <div class="title-container">
                <h1 class="aging-title">Workorder Aging & Summary</h1>
            </div>
        </div>
    </div>
    <!-- Workorder Aging Section -->
    <div class="card-row" *ngIf="dataAging.length">
        <mat-card class="user-card">
            <div class="card-header" [ngClass]="{backButton: !selectedRecord}">
                <mat-card-title class="card-title">
                    <span class="custom-badge" matBadge="{{dataAging.length > 0 && detailAging.length == 0 ? dataAging.length : detailAging.length}}"
                        matBadgeOverlap="false">Workorder Aging</span>
                </mat-card-title>
                <div class="selected-record" *ngIf="selectedRecord" matTooltip="{{selectedRecord}}" [ngClass]="{'truncated': isLabelTooLong(selectedRecord)}">{{selectedRecord}}</div>
                <button mat-flat-button color="primary" class="back-button" *ngIf="detailAging.length > 0"
                    (click)="refresh()">Back</button>
            </div>
            <mat-divider></mat-divider>
            <div class="table-container">
                <table *ngIf="dataAging.length > 0 && detailAging.length == 0"  id="gridvalue">
                    <thead>
                        <tr>
                            <th *ngFor="let head of dataAging[0] | keyvalue : originalOrder"
                                [ngStyle]="{'display': head.key == 'Status_Cd' || head.key == 'Programdetail_Id' || head.key == 'Fromstatus_Cd' ? 'none' : 'table-cell'}">
                                {{head.key}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of dataAging" (click)="getAgingDetail(item)">
                            <td *ngFor="let list of item | keyvalue : originalOrder"
                                [ngStyle]="{'display': list.key == 'Status_Cd' || list.key == 'Programdetail_Id' || list.key == 'Fromstatus_Cd' ? 'none' : 'table-cell'}">
                                {{item[list.key]}}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table *ngIf="detailAging.length > 0" >
                    <thead>
                        <tr>
                            <th *ngFor="let head of detailAging[0] | keyvalue : originalOrder"
                                [ngStyle]="{'display': head.key == 'EnrollmentId' || head.key == 'GroupId' || head.key == 'SubGroupId' || head.key == 'SubGroup1' ? 'none' : 'table-cell'}">
                                {{head.key}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of detailAging" (click)="handleEnrollmentWorkorderClick(item)">
                            <td *ngFor="let list of item | keyvalue : originalOrder"
                                [ngStyle]="{'display': list.key == 'EnrollmentId' || list.key == 'GroupId' || list.key == 'SubGroupId' || list.key == 'SubGroup1' ? 'none' : 'table-cell'}">
                                {{item[list.key]}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-card>
        <mat-card class="user-card chart-card">
            <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [legend]="true"
                [type]="'bar'"></canvas>
        </mat-card>
    </div>

    <!-- Workorder Exception Summary Section -->
    <div class="card-row" *ngIf="dataExceptionSummary.length">
        <mat-card class="user-card">
            <div class="card-header" [ngClass]="{backButton: !selectedException}">
                <mat-card-title class="card-title">
                    <span class="custom-badge" matBadge="{{dataExceptionSummary.length > 0 && detailSummary.length == 0 ? dataExceptionSummary.length : detailSummary.length}}"
                        matBadgeOverlap="false">Workorder Exception Summary</span>
                </mat-card-title>
                <span class="selected-record" *ngIf="selectedException" matTooltip="{{selectedException}}" [ngClass]="{'truncated': isLabelTooLong(selectedException)}">{{selectedException}}</span>
                <button mat-flat-button color="primary" class="back-button" *ngIf="detailSummary.length > 0"
                    (click)="refreshSummary()">Back</button>
            </div>
            <mat-divider></mat-divider>
            <div class="table-container">
                <table *ngIf="dataExceptionSummary.length > 0 && detailSummary.length == 0" 
                    id="exceptiongridvalue">
                    <thead>
                        <tr>
                            <th *ngFor="let head of dataExceptionSummary[0] | keyvalue : originalOrder"
                                [ngStyle]="{'display': head.key == 'ExceptionCd' ? 'none' : 'table-cell'}">
                                {{head.key}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of dataExceptionSummary; let index = index"
                            [class.curr-cust]="index == selectedRowIndex" (click)="getSummaryDetail(item)">
                            <td *ngFor="let list of item | keyvalue : originalOrder"
                                [ngStyle]="{'display': list.key == 'ExceptionCd' ? 'none' : 'table-cell'}">
                                {{item[list.key]}}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table *ngIf="detailSummary.length > 0" >
                    <thead>
                        <tr>
                            <th *ngFor="let head of detailSummary[0] | keyvalue : originalOrder"
                                [ngStyle]="{'display': head.key == 'Exception' || head.key == 'EnrollmentId' || head.key == 'GroupId' || head.key == 'SubGroupId' || head.key == 'SubGroup1' ? 'none' : 'table-cell'}">
                                {{head.key}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of detailSummary" (click)="handleEnrollmentWorkorderClick(item)">
                            <td *ngFor="let list of item | keyvalue : originalOrder"
                                [ngStyle]="{'display': list.key == 'Exception' || list.key == 'EnrollmentId' || list.key == 'GroupId' || list.key == 'SubGroupId' || list.key == 'SubGroup1' ? 'none' : 'table-cell'}">
                                <span class="truncate-text" matTooltip="{{item[list.key]}}">{{item[list.key]}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-card>
        <mat-card class="user-card chart-card">
            <canvas baseChart [datasets]="barChartDataSummary" [labels]="barChartLabelSummary" [legend]="true"
                [type]="'bar'" [options]="chartOptions" (chartClick)="chartClicked($event)"></canvas>
        </mat-card>
    </div>

    <!-- Installer Production Section -->
    <div class="card-row" *ngIf="installerProd.length">
        <mat-card class="user-card">
            <div class="card-header" style="padding: 1rem 0.5rem;">
                <mat-card-title class="card-title">
                    <span class="custom-badge" matBadge="{{installerProd.length}}" matBadgeOverlap="false">Installer Production</span>
                </mat-card-title>
            </div>
            <mat-divider></mat-divider>
            <div class="table-container">
                <table *ngIf="installerProd.length > 0"  id="installergridvalue">
                    <thead>
                        <tr>
                            <th *ngFor="let head of installerProd[0] | keyvalue : originalOrder"
                                [ngStyle]="{'display': head.key == 'Org_cd' || head.key == 'Personcompany_Id' ? 'none' : 'table-cell'}">
                                {{head.key}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of installerProd">
                            <td *ngFor="let list of item | keyvalue : originalOrder"
                                [ngStyle]="{'display': list.key == 'Org_cd' || list.key == 'Personcompany_Id' ? 'none' : 'table-cell'}">
                                {{item[list.key]}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-card>
        <mat-card class="user-card chart-card">
            <canvas baseChart [datasets]="barChartInstaller" [labels]="barChartLabelInstaller" [legend]="true"
                [type]="'bar'" [options]="chartOptions"></canvas>
        </mat-card>
    </div>

    <!-- Hold Reason Summary Section -->
    <div class="card-row" *ngIf="dataHoldReasonSummary.length">
        <mat-card class="user-card">
            <div class="card-header" [ngClass]="{backButton: !selectedReason}">
                <mat-card-title class="card-title">
                    <span class="custom-badge" matBadge="{{dataHoldReasonSummary.length > 0 && detailHoldReasonSummary.length == 0 ? dataHoldReasonSummary.length : detailHoldReasonSummary.length}}"
                        matBadgeOverlap="false">Hold Reason Summary</span>
                </mat-card-title>
                <span class="selected-record" *ngIf="selectedReason" matTooltip="{{selectedReason}}" [ngClass]="{'truncated': isLabelTooLong(selectedReason)}">{{selectedReason}}</span>
                <button mat-flat-button color="primary" class="back-button" *ngIf="detailHoldReasonSummary.length > 0"
                    (click)="refreshReasonSummary()">Back</button>
            </div>
            <mat-divider></mat-divider>
            <div class="table-container">
                <table *ngIf="dataHoldReasonSummary.length > 0 && detailHoldReasonSummary.length == 0"
                     id="reasongridvalue">
                    <thead>
                        <tr>
                            <th *ngFor="let head of dataHoldReasonSummary[0] | keyvalue : originalOrder"
                                [ngStyle]="{'display': head.key == 'Reason_cd' ? 'none' : 'table-cell'}">
                                {{head.key}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of dataHoldReasonSummary; let index = index"
                            [class.curr-cust]="index == selectedRowIndex" (click)="getHoldReasonDetail(item)">
                            <td *ngFor="let list of item | keyvalue : originalOrder"
                                [ngStyle]="{'display': list.key == 'Reason_cd' ? 'none' : 'table-cell'}">
                                {{item[list.key]}}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table *ngIf="detailHoldReasonSummary.length > 0" >
                    <thead>
                        <tr>
                            <th *ngFor="let head of detailHoldReasonSummary[0] | keyvalue : originalOrder"
                                [ngStyle]="{'display': head.key == 'ReasonDesc' || head.key == 'EnrollmentId' || head.key == 'GroupId' || head.key == 'SubGroupId' || head.key == 'SubGroup1' ? 'none' : 'table-cell'}">
                                {{head.key}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of detailHoldReasonSummary" (click)="handleEnrollmentWorkorderClick(item)">
                            <td *ngFor="let list of item | keyvalue : originalOrder"
                                [ngStyle]="{'display': list.key == 'ReasonDesc' || list.key == 'EnrollmentId' || list.key == 'GroupId' || list.key == 'SubGroupId' || list.key == 'SubGroup1' ? 'none' : 'table-cell'}">
                                {{item[list.key]}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-card>
        <mat-card class="user-card chart-card">
            <canvas baseChart [datasets]="barChartDataReason" [labels]="barChartLabelReason" [legend]="true"
                [type]="'bar'" [options]="chartOptions" (chartClick)="chartReasonClicked($event)"></canvas>
        </mat-card>
    </div>
</div>